import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "react-hot-toast";

import reportWebVitals from "./utils/reportWebVitals";

import Navbar from "./components/Navbar";
import Footer from "./sections/Footer";

import About from "./sections/About";
import Industries from "./sections/Industries";
import Product from "./sections/Product";
import Contact from "./sections/Contact";
import Service from "./sections/Service";
import ProductDetail from "./sections/ProductDetail";
import ServiceDetail from "./sections/ServiceDetail";
import ProductPage from "./sections/ProuducPage";
import PrivacyPolicy from "./sections/PrivacyPolicy";
import TermsOfService from "./sections/TermsOfService";
import { Scroll } from "lucide-react";
import ScrollToTop from "./components/ScrollToTop";

function PublicLayout() {
  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <ScrollToTop />
    <AuthProvider>
      <Toaster position="top-center" />

      <Routes>
        {/* Public */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<App />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<Service />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
          <Route path="/product" element={<Product />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/products" element={<ProductPage />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Route>
      </Routes>
    </AuthProvider>
  </BrowserRouter>,
);

reportWebVitals();
